import { Link, useParams } from "react-router-dom";
import { useClientPortalPaths } from "../../hooks/useClientPortalBase";
import { MIDPOINT_MEDIA_ADMIN_PORTAL_BASE } from "../../constants/clientAdminPortalRoutes";

const REPORT_CARDS = [
  { path: "opportunities", title: "Opportunity Report", description: "Detailed lead table with filters and export" },
  { path: "communities", title: "Community Interest Report", description: "Which communities drive the most interest" },
  { path: "courses", title: "Course Interest Report", description: "Course-level inquiry performance" },
  { path: "sources", title: "Source Attribution Report", description: "Where your leads are coming from" },
  { path: null, title: "Sponsor Performance", description: "Coming soon", disabled: true },
];

const ClientReportsHubPage = () => {
  const { clientViewId } = useParams();
  const paths = useClientPortalPaths();
  const cards =
    paths.base === MIDPOINT_MEDIA_ADMIN_PORTAL_BASE
      ? REPORT_CARDS.filter((card) => card.path === "opportunities" || card.path === "sources")
      : REPORT_CARDS;

  return (
    <>
      <section className="panel-card">
        <p className="eyebrow">
          <Link to={paths.viewSection(clientViewId, "analytics")}>Analytics</Link> / Reports
        </p>
        <h2>Reports</h2>
        <p className="muted">Detailed reporting for your Client View</p>
      </section>

      <div className="client-view-card-grid">
        {cards.map((card) =>
          card.disabled ? (
            <article key={card.title} className="panel-card client-view-card muted">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </article>
          ) : (
            <Link
              key={card.path}
              to={paths.viewSection(clientViewId, "reports", card.path)}
              className="panel-card client-view-card"
            >
              <h3>{card.title}</h3>
              <p className="muted">{card.description}</p>
            </Link>
          )
        )}
      </div>
    </>
  );
};

export default ClientReportsHubPage;
